import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileImportLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.5858 2C14.0573 2 14.5116 2.16649 14.8702 2.46691L15 2.58579L19.4142 7C19.7476 7.3334 19.9511 7.77238 19.9923 8.23836L20 8.41421V20C20 21.0544 19.1841 21.9182 18.1493 21.9945L18 22H12V20H18V10H13.5C12.7203 10 12.0796 9.40511 12.0069 8.64446L12 8.5V4H6V12H4V4C4 2.94564 4.81588 2.08183 5.85074 2.00549L6 2H13.5858ZM7.70705 14.4645L10.5355 17.2929C10.926 17.6834 10.926 18.3166 10.5355 18.7071L7.70705 21.5355C7.31652 21.9261 6.68336 21.9261 6.29284 21.5355C5.90231 21.145 5.90231 20.5118 6.29284 20.1213L7.41416 19H3C2.44772 19 2 18.5523 2 18C2 17.4477 2.44772 17 3 17H7.41416L6.29284 15.8787C5.90231 15.4882 5.90231 14.855 6.29284 14.4645C6.68336 14.0739 7.31652 14.0739 7.70705 14.4645ZM14 4.41421V8H17.5858L14 4.41421Z"
	})
});
export default SvgFileImportLine;
